import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient singleton.
 *
 * Extracted from main.tsx so store/auth.ts can import it without creating a
 * circular dependency (main.tsx → App → Layout → store/auth → main.tsx).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // PAUSE polling when tab is hidden. Without this, every dashboard
      // tab left open in the background continues polling on its
      // refetchInterval — multi-tab users were generating ~6.8 req/sec
      // round-the-clock against the API worker (73k requests in 3h on
      // a quiet account). When user returns to the tab, polling resumes
      // automatically. Apply globally so individual queries don't have
      // to opt in.
      refetchIntervalInBackground: false,
    },
  },
});
